module.exports = __webpack_public_path__ + "static/media/ph.static.c0326d83.svg";